import React, { useEffect, useState } from 'react';
import AsButton from '../../AsButton';
import IconClose from '../../svg/IconClose';
import ColumnOption from './ColumnOption';

const closeIcon = {
    width: 19,
    height: 19
};

const ColumnOptionList = ({
    visible = false,
    columns,
    onChange,
    onClose,
    panelWidth = 200,
    showApplyButton,
    onFilterClose
}) => {
    const filterPanel = {
        position: 'absolute',
        boxSizing: 'border-box',
        border: '1px solid #CCCCCC',
        borderRadius: '0 0 15px 15px',
        backgroundColor: '#FFFFFF',
        boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
        paddingBottom: 10,
        width: panelWidth < 200 ? 200 : panelWidth,
        marginLeft: panelWidth > 200 ? (panelWidth - 200) * -1 : 0,
        zIndex: 300
    };

    const createButton = {
        width: 105,
        height: 40,
        fontSize: 14,
        fontWeight: 'bold'
    };

    const [localColumns, setLocalColumns] = useState();
    useEffect( ()=> {
        setLocalColumns( columns.map(c => ({
            headerName: c.headerName,
            field: c.field,
            showInList: c.showInList,
            hideInColumnFilter: c.hideInColumnFilter,
            displayOrder: c.displayOrder
        })));
    }, [columns] );

    const handleChange = (field)=>{
        const newColumns = [...localColumns];
        const column = newColumns.find(c => c.field === field);
        column.showInList = !column.showInList;
        setLocalColumns(newColumns);

        if (!showApplyButton){
            onChange(field);
        }
    }

    const handleApplyButtonClick = () => {
        const newColumns = [...columns];
        for (let column of newColumns){
            column.showInList = localColumns.find(c => c.field === column.field).showInList;
        }
        onFilterClose(newColumns);
        onClose();
    };

    return (
        visible && (
            <div style={filterPanel}>
                <div style={{ textAlign: 'right' }}>
                    <IconClose style={closeIcon} onClick={() => onClose()} />
                </div>
                {localColumns
                    .filter((c) => !c.hideInColumnFilter)
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((c) => (
                        <ColumnOption
                            key={c.headerName}
                            text={c.headerName}
                            field={c.field}
                            showInList={c.showInList}
                            onChange={handleChange}
                        />
                    ))}
                <div>
                    {showApplyButton && (
                        <AsButton
                            style={createButton}
                            handleClick={() => handleApplyButtonClick()}
                        >
                            Apply
                        </AsButton>
                    )}
                </div>
            </div>
        )
    );
};

export default ColumnOptionList;
